import { ChevronLeft, ChevronRight } from "lucide-react";
import { useIntl } from "react-intl";
import Message from "../../../../../i18n/Message";
import label from "../../../../../i18n/label";
import { currentModelDescriptions } from "../../../../../model/model-providers/modelDescriptors";
import "./RequestLogTable.scss";

const getModelDisplayName = (modelId) => {
  if (!modelId) return "—";
  const descriptor = currentModelDescriptions.find((m) => m.id === modelId);
  return descriptor?.name || modelId;
};

const RequestLogTable = ({ data, page, onPageChange, onRowClick }) => {
  const intl = useIntl();
  const items = data?.items || [];
  const totalPages = data?.totalPages || 0;

  const formatDuration = (ms) => {
    if (ms === null || ms === undefined) return "—";
    if (ms < 1000) return `${ms} ms`;
    return `${(ms / 1000).toFixed(2)} s`;
  };

  const formatTokens = (tokens) => {
    if (tokens === null || tokens === undefined) return "—";
    if (tokens >= 1000) return `${(tokens / 1000).toFixed(1)}k`;
    return tokens.toString();
  };

  return (
    <div className="request_log_table card">
      <div className="table_header">
        <h4>
          <Message id="request_logs" />
        </h4>
      </div>
      <div className="table_container">
        <table>
          <thead>
            <tr>
              <th>{label(intl, "log_date")}</th>
              <th>{label(intl, "log_model")}</th>
              <th>{label(intl, "log_ttft")}</th>
              <th>{label(intl, "log_duration")}</th>
              <th>{label(intl, "log_tokens_per_sec")}</th>
              <th>{label(intl, "log_input")}</th>
              <th>{label(intl, "log_output")}</th>
              <th>{label(intl, "log_reasoning")}</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="8" className="no_data">
                  <Message id="no_request_logs" />
                </td>
              </tr>
            ) : (
              items.map((item) => (
                <tr
                  key={item.uid}
                  className="clickable"
                  onClick={() => onRowClick && onRowClick(item.uid)}
                >
                  <td className="date_cell">
                    {new Date(item.dateCreated).toLocaleString()}
                  </td>
                  <td className="model_cell" title={item.modelId}>
                    {getModelDisplayName(item.modelId)}
                  </td>
                  <td>{item.ttftMs !== null ? `${item.ttftMs} ms` : "—"}</td>
                  <td>{formatDuration(item.durationMs)}</td>
                  <td>
                    {item.tokensPerSecond !== null
                      ? item.tokensPerSecond.toFixed(1)
                      : "—"}
                  </td>
                  <td>{formatTokens(item.inputTokens)}</td>
                  <td>{formatTokens(item.outputTokens)}</td>
                  <td>{formatTokens(item.reasoningTokens)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 0 && (
        <div className="table_pagination">
          <button
            className="page_btn"
            onClick={() => onPageChange(page - 1)}
            disabled={page === 0}
          >
            <ChevronLeft size={16} /> {label(intl, "pagination_previous")}
          </button>
          <span className="page_info">
            <Message
              id="pagination_page_info"
              values={{ current: page + 1, total: totalPages }}
            />
          </span>
          <button
            className="page_btn"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages - 1}
          >
            {label(intl, "pagination_next")} <ChevronRight size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default RequestLogTable;
